<!-- HEADER -->
<app-header
  [class.show-background]="showToolbar"
  color="transparent"
  class="header-override"></app-header>

<!-- CONTENT -->
<ion-content
  class="padded"
  [scrollEvents]="true"
  (ionScroll)="onScroll($event)">
  <!-- HERO -->
  <ng-container *ngIf="hero; else featuredImage">
    <app-hero [node]="hero"></app-hero>
  </ng-container>
  <ng-template #featuredImage>
    <div class="hero">
      <app-img-format
        *ngIf="data?.featuredImage"
        [src]="data?.featuredImage"
        [alt]="data?.title"
        [aspectRatio]="'16:9'"
        [disableLazyLoad]="true"></app-img-format>
      <ion-text
        [color]="data?.fontShade && data?.fontShade === 'dark' ? 'primary' : 'light'">
        <h1 class="hero-title">{{data?.title | uppercase}}</h1>
      </ion-text>
    </div>
  </ng-template>

  <section>
    <!-- BODY -->
    <app-dynamic-html
      *ngIf="data?.body?.blocks"
      [data]="data.body"
      [publicForm]="true"></app-dynamic-html>
  </section>

  <!-- CONTACT / CTA STRIP -->
  <app-contact-strip></app-contact-strip>

  <!-- FOOTER -->
  <app-footer></app-footer>
</ion-content>
